import { type ApiRequest, type ApiResponse, callApi, properCallApi } from '@/api/tenantClient';
import { type RegistrationMode } from '../constant';

export interface Venue {
  name: string
}
export interface Event {
  id: string
  eventType: string
  name: string
  location: string
  description: string
  shortName: string
  tagline: string
  primaryColour: string
  secondaryColour: string
  startDate: string
  endDate: string
  coverImage: string
  registrationBanner: string
  menuLogo: string
  startTime: string
  endTime: string
  websiteUrl: string
  mapUrl: string
  venues: Venue[]
  tzInfoName: string
  registrationMode: RegistrationMode
  timeZone: string
}

export const eventQueryKey = 'registration.event';

export const eventListQueryKey = 'registration.eventList';

export interface EventListData {
  items: Event[]
}

export interface EventListQueryRequest {}

export function loadEventList(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (): Promise<ApiResponse<Event>> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/events';
    return await properCallApi<ApiResponse<Event>>(request);
  };
}

export interface EventQueryRequest {
  eventId: string
}

export function loadEvent(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: EventQueryRequest
  ): Promise<ApiResponse<Event>> => {
    request.method = 'GET';
    request.endpoint.path = `/api/v1/events/${params.eventId}`;
    return await callApi<Event>(request);
  };
}

export interface EventUpdateRequest {
  event: Partial<Event>
}

export function updateEvent(createTenantAdminRequest: () => ApiRequest) {
  const request = createTenantAdminRequest();
  return async (params: EventUpdateRequest): Promise<ApiResponse<Event>> => {
    if (params.event.id) {
      request.method = 'PUT';
      request.endpoint.path = '/api/v1/events/' + params.event.id;
      request.payload = params;
    } else {
      request.method = 'POST';
      request.endpoint.path = '/api/v1/events';
      request.payload = params;
    }
    return await properCallApi<ApiResponse<Event>>(request);
  };
};
